import { UserModel } from "@/model/user/userModel";

export function ConvertToUserModel(userInfo: any): UserModel {
  const userModel: UserModel = {
    userId: userInfo.id,
    displayName: userInfo.given_name,
    lastLogInDateTime: userInfo.lastLogInDateTime,
    registerDateTime: userInfo.registerDateTime,
    phone: userInfo.phone_number,
    pictureUrl: userInfo.picture,
    signatureUrl: userInfo.signatureUrl,
    userEmail: userInfo.userEmail,
    firstName: userInfo.firstName,
    lastName: userInfo.lastName,
    birthdate: userInfo.birthdate,
    departmentId: userInfo.departmentId,
    departmentOther: userInfo.departmentOther,
    positionId: userInfo.positionId,
    positionOther: userInfo.positionOther,
    emailVerificationStatus: userInfo.emailVerificationStatus,
    twoFactorAuthenticationTypeId: userInfo.twoFactorAuthenticationTypeId,
    userPINStatusId: userInfo.userPINStatusId,
  };

  return userModel;
}
